module.exports = __webpack_public_path__ + "media/newstyle/images/stars_2-orange-2249a41541373f77ae55460281577f80.svg";